import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProps } from "./Icon.d";
export const Icon: FC<IconProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <FontAwesomeIcon {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default Icon;